<template>
  <div>
    <a id="sb_policy"></a>
    <div style="margin-bottom:1.5rem">
      <div class="box">
        <admin-box-item title="정책">
          <admin-form-item label="객실 설정">
            <div class="columns is-multiline">
              <div class="column is-3-desktop">
                <div class="txt-label">기준 인원</div>
                <select class="input-border" v-model="value.minimum">
                  <option v-for="(opt,idx) in option.minimum" :key="`opt-unit-person-${idx}`"
                          :value="opt.value">{{ opt.label }}</option>
                </select>
              </div>
              <div class="column is-3-desktop">
                <div class="txt-label">최대 인원</div>
                <select class="input-border" v-model="value.maximum">
                  <option v-for="(opt,idx) in option.maximum" :key="`opt-max-person-${idx}`"
                          :value="opt.value">{{ opt.label }}</option>
                </select>
              </div>
              <div class="column is-6-desktop">
                <div class="txt-label">초과 요금(인당)</div>
                <div class="flex-align" style="padding-right: 32px">
                  <input class="input-border" type="number"
                    placeholder="0" min="0" @keyup="e => keyupNum('over_price', e)" v-model="value.over_price">
                  <div class="size-14" style="margin-left:4px">원</div>
                </div>
              </div>
              <div class="column is-3-desktop">
                <div class="txt-label">체크인</div>
                <time-picker
                  :value.sync="value.check_in"></time-picker>
              </div>
              <div class="column is-3-desktop">
                <div class="txt-label">체크아웃</div>
                <time-picker
                  :value.sync="value.check_out"></time-picker>
              </div>
              <div class="column is-3-desktop">
                <div class="txt-label">최소 숙박일</div>
                <input class="input-border" type="number"
                  placeholder="0" min="0" v-model="value.min_period"
                  @keyup="e => keyupNum('min_period', e)">
              </div>
              <div class="column is-3-desktop">
                <div class="txt-label">최대 숙박일</div>
                <input class="input-border" type="number"
                  placeholder="0" min="0" @keyup="e => keyupNum('max_period', e)" v-model="value.max_period">
              </div>
            </div>
            <div class="columns">
              <div class="column is-4-desktop" style="padding-bottom:0 !important">
                <div class="txt-label" style="margin-bottom:0">침대 종류</div>
              </div>
              <div class="column is-3-desktop" style="padding-bottom:0 !important">
                <div class="txt-label" style="margin-bottom:0">침대 개수</div>
              </div>
            </div>
            <div class="columns" v-for="(bed, bidx) in value.bed" :key="`bed-${bidx}`">
              <div class="column is-4-desktop">
                <select class="input-border" v-model="bed.type">
                  <option v-for="(item,idx) in option.bed" :key="`option-bed-${idx}`"
                          :value="item.value">{{ item.label }}</option>
                </select>
              </div>
              <div class="column is-3-desktop">
                <div class="flex-align">
                  <input class="input-border" type="number" v-model="bed.num" @keyup="e => bed.num = Number(e.target.value)">
                  <div v-if="bidx > 0"
                    class="unselect button-remove" @click="clickRemove(bidx)">
                    <i class="material-icons">close</i>
                  </div>
                  <div v-else style="width:32px"></div>
                </div>
              </div>
            </div>
            <div style="height: 33px">
              <div class="unselect button-add" @click="clickAdd">+ 침대 종류 추가</div>
            </div>
          </admin-form-item>
        </admin-box-item>
      </div>
    </div>

    <a id="sb_convenience"></a>
    <div style="margin-bottom:1.5rem">
      <div class="box position-relative">
        <admin-box-item title="편의시설">
          <div class="button-edit" @click="clickEdit">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.37333 4.51333L7.98667 5.12667L1.94667 11.1667H1.33333V10.5533L7.37333 4.51333ZM9.77333 0.5C9.60667 0.5 9.43333 0.566667 9.30667 0.693333L8.08667 1.91333L10.5867 4.41333L11.8067 3.19333C12.0667 2.93333 12.0667 2.51333 11.8067 2.25333L10.2467 0.693333C10.1133 0.56 9.94667 0.5 9.77333 0.5ZM7.37333 2.62667L0 10V12.5H2.5L9.87333 5.12667L7.37333 2.62667Z" fill="#FF5722"/>
            </svg>편집
          </div>
          <admin-form-item label="편의시설">
            <div class="columns is-multiline" style="padding-top:12px">
              <div v-for="(item,idx) in value.convenience" :key="`cv-${idx}`"
                class="column is-full-mobile is-4-tablet is-3-desktop">
                <lp-check-bool :checkedVal.sync="item.checked" :label="item.name"></lp-check-bool>
              </div>
            </div>
          </admin-form-item>
        </admin-box-item>
      </div>
    </div>
    <modal-convenience ref="convModal" :convs="convs" @accept="acceptConv"></modal-convenience>
  </div>
</template>

<script>
  import TimePicker from "../../../module/common/TimePicker";
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import ModalConvenience from "./ModalConvenience";
  export default {
    name: "PanelBookingPolicy",
    components: {ModalConvenience, LpCheckBool, TimePicker},
    props: {
      prod: {
        type: Object
      }
    },
    data() {
      return {
        option: {
          minimum: [],
          maximum: [],
          bed:[]
        },
        value: {
          minimum: 1,
          maximum: 1,
          over_price: 0,
          bed: [
            {
              type: '싱글사이즈',
              num: 1
            }
          ],
          check_in: '',
          check_out: '',
          min_period: 1,
          max_period: 1,
          convenience: [
            {name: "에어컨", checked: false},
            {name: "무선인터넷", checked: false},
            {name: "TV", checked: false},
            {name: "욕조", checked: false},
            {name: "금고", checked: false},
            {name: "냉장고", checked: false},
            {name: "샤워시설", checked: false},
            {name: "주방", checked: false},
            {name: "전화", checked: false},
            {name: "드라이기", checked: false},
            {name: "수건", checked: false},
            {name: "에어컨", checked: false},
          ],
        },
        convs: []
      }
    },
    created() {
      if(this.prod.booking_policy) {
        this.value = this.prod.booking_policy;
      }
      this.init();
    },
    methods: {
      init() {
        for(let i=1; i<=10; i++) {
          ['maximum','minimum'].forEach(key => {
            this.option[key].push({
              label: `${i}명`,
              value: i
            })
          })
        }
        this.option.bed = ['싱글사이즈','더블사이즈','퀸사이즈','킹사이즈','트윈사이즈','슈퍼킹사이즈','이불'].map(i => {
          return {
            label: i,
            value: i
          }
        });
      },
      keyupNum(item, e) {
        this.value[item] = Number(e.target.value);
      },
      clickRemove(bidx) {
        removeIndex(this.value.bed, bidx);
      },
      clickAdd() {
        this.value.bed.push({
          type: '싱글사이즈',
          num: 1
        })
      },
      clickEdit() {
        this.convs = this.cloneItem(this.value.convenience);
        setTimeout(()=>{
          this.$refs.convModal.open();
        },100);
      },
      acceptConv(item) {
        this.value.convenience = item;
        this.convs = [];
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .box
    box-shadow unset
  .input-border
    border 1px solid #cccccc
    border-radius 4px
    padding 7px
    width 100%
    flex 1
  input[type=number]
    color #363636

  .txt-label
    margin-bottom 6px
    font-size 14px

  .button-edit
    position absolute
    top -4px
    right 32px
    background-color rgba(255, 206, 166, 0.3)
    color #ff5722
    font-size 13px
    padding 6px 16px
    border-radius 32px
    z-index 1
    cursor pointer
    display flex
    align-items center
    justify-content center
    gap 0 6px

  .button-add
    color #ff5722
    margin-top 12px
    float left
    clear both
  .button-remove
    background-color #eeeeee
    width 20px
    height 20px
    border-radius 100%
    display flex
    align-items center
    justify-content center
    margin-left 12px
    i
      font-size 15px
</style>
